// See the URL "https://github.com/rails/execjs#readme" for more supported runtimes
// import 'core-js/stable'
// import 'regenerator-runtime/runtime'

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// Import Stimulus controllers
import "../controllers"

Rails.start()
ActiveStorage.start()
